$(document).ready(function () {
  if( typeof __default_variant!="undefined" ){
    $('.product__zoom').on('init', function(event, slick){
      
      setTimeout(function(){ 
        var variant = __default_variant;
        if( typeof variant.featured_image == "undefined" || variant.featured_image==null  ) return;
        var slideIndex = $('[data-image-id="' + variant.featured_image.id +'"]').parents('.slick-slide').data('slick-index');
        $('.product__zoom .product-slider-gallery').slick('slickGoTo', parseInt(slideIndex));
	    $('.product-slider-gallery-nav').slick('slickGoTo', parseInt(slideIndex));
      }, 1000);
    });
  }
  setTimeout(function(){ 
    OptiMonk.$ = jQuery;
  }, 2000);

  // RQ! swatch condtions for "swatch-color_" START
  setTimeout(function () {
     $(".rq-new-color-space").show();
  }, 500);   
  /*var gb = $("li").closest(".rq-ul-color-swatch").find(".rq-have-tag-swatch").html();
  if(gb) {
     $(".rq-have-tag-swatch").closest("li.HorizontalList__Item.rq-color-margin").find(".rq-no-have-tag-swatch").hide();
  }*/
  $('.newcolor-swatc').each(function() {
      if (!$(this).attr('data-tooltip')) { 
        //var gb =  $(this).attr('data-tooltip-notag');
        var gb = $("li").closest(".rq-ul-color-swatch").find(this).attr('data-tooltip-notag');
        $(this).attr('data-tooltip' ,gb );
      }
  });
  
  // RQ! swatch condtions for "swatch-color_" ENDS
  
});
  
/*RQ! 'PDP modifications' STARTS*/
$(document).ready(function(){
    $("a").on('click', function(event) {
       window.location.hash = '';
        if (this.hash !== "") {
            event.preventDefault();
            var hash = this.hash;
            $('html, body').animate({
                scrollTop: $(hash).offset().top
            }, 800);
        }
    });
});
/*RQ! 'PDP modifications' ENDS*/

function InfinityShowProduct(max_count,collection_handle, collection_id) {
  this.timer_show = null;
  this.current_page = 0;
  this.max_per_page = 12;
  this.collection_handle = collection_handle;
  this.collection_id = collection_id;

  this.bloom_collection_on = ((collection_id+"") == "384720914");

  this.max_page = Math.ceil( max_count/this.max_per_page );
  this.model_product = `
<li id="gridprod-{id}" class="collection-grid__item" data-ref="item" data-pid="{id}">
  <a class="collection-grid-item__link" href="/collections/{collection_handle}/products/{handle}">
    <div class="collection-grid__item-tags">
      {tag_str}
    </div>
<div class="collection-grid-item__images">
	  <div class="img-square">
        {images_str}
        <div class="img-swatch">
          <img/>
        </div>
      </div>
    </div>
    <div class="collection-grid-item__info">
      {texts_str}
    </div>
  </a>
  <div class="collection-grid-item__bottom-container">
    {prices_str}
  </div>
  <div class="collection-swatch">
    {color_swatch}
  </div>
  <div class="collection-grid-item__bottom-container collection-grid-item__bottom-container--atc">
	<a class="button button--purple" href="/collections/{collection_handle}/products/{handle}">View Product &gt;</a>
  </div>
</li>`;
  
}

InfinityShowProduct.prototype.tryShowMore=function(){
  if( this.timer_show!=null ) clearTimeout(this.timer_show);
  this.timer_show = setTimeout(function(){ this.showMore(); }.bind(this), 500);
}

InfinityShowProduct.prototype.showMores=function(jump_to_page){
  for(;this.current_page<=jump_to_page; ){
    this.showMore();
  }
}

InfinityShowProduct.prototype.showMore=function(){
  //console.log("show");
  this.current_page++;
  let current_product_array = [];
  let current_offset = (this.current_page-1)*this.max_per_page;
  let pull_count = 0;
  for(let i=current_offset;i<data_products.length;i++ ){
    current_product_array.push(data_products[i]);
    pull_count++;
    if( pull_count>=this.max_per_page ) break;
  }
  
  //console.log(current_product_array);
  for(let i=0;i<current_product_array.length;i++){
    let product = current_product_array[i];
    let tmp = this.model_product;
    let color_swatch = this.variantColors(product);
    //console.log(color_swatch);
    
    tmp = tmp.replaceAll("{id}",product.id);
    tmp = tmp.replaceAll("{collection_handle}",this.collection_handle);
    tmp = tmp.replaceAll("{handle}",product.handle);
    tmp = tmp.replaceAll("{images_str}",this.renderImages(product));
    tmp = tmp.replaceAll("{texts_str}",this.renderTexts(product));
    debugger;
    //tmp = tmp.replaceAll("{prices_str}",this.renderPrices(product));
    tmp = tmp.replace("{prices_str}",this.renderPrices(product));
    tmp = tmp.replaceAll("{tag_str}",this.renderTag(product));
    tmp = tmp.replaceAll("{color_swatch}",color_swatch);
    
    $("#collection-grid").append(tmp);

    this.bloomQueryVisiblePhotos(product);
      // once it's appended and the images are in the dom, see which photos need to be visible
  }
  this.updateURLState();
  
  //Hide the load button when all the products loaded.
  if( current_product_array.length==0 ) $("#loadMore").hide();
  
  //Hide the swatch image when hovering.
  $(".img-swatch").hover(function() {
    $( this ).find("img").attr( "src","" );
  });
  
  clearTimeout(this.timer_show);
  //StampedFn.reloadUGC();
}
InfinityShowProduct.prototype.variantColors=function(product){
  let colors = {};
  let colors_array = [];
  //console.log(product.variants);
  for( let i=0;i<product.variants.length;i++ ){
    let variant = product.variants[i];
    let color = variant.option2;
    if( variant.featured_image==null ) continue;
    let image = variant.featured_image.src;
    if( !colors_array.includes(color) ) colors_array.push(color);
    colors[color] = image;
  }
  
  let tmp = '';
  //console.log(colors_array.length);
  if( colors_array.length>1 ){
    tmp += '<ul class="variant__swatch variant__list--color">';
    for( let color_u in colors ){
      var i = Object.keys(colors).indexOf(color_u);
      //debugger;
      var active_item = '';
      if (i == 0) { active_item = 'active' }
      let src = colors[color_u];
      let color = color_u.toLocaleLowerCase().replace(/ /g,"-");
      tmp += '<li class="variant__item variant__swatch-wrap"><a onclick="__obj_ISP.swatchClick(this)" class="'+active_item+' variant__link variant__link--available variant__swatch color--'+color+'" data-cvalue="color--'+color+'" data-src="'+src+'"></a></li>';
    }
    tmp += '</ul>';
  }
  
  return tmp;
}
InfinityShowProduct.prototype.swatchClick=function(obj){
  //console.log( $(obj).data("src") );
  //console.log( $(obj).closest("li.collection-grid__item").find(".img-swatch > img").length );
  $(obj).parents('.variant__list--color').find('a').removeClass('active');
  $(obj).addClass('active');  
  $(obj).closest("li.collection-grid__item").find(".img-swatch > img").attr("src",$(obj).data("src"));
}
InfinityShowProduct.prototype.renderTag=function(product){
  let str = "";
  if( !product.available ){}
  else if( product.selected_or_first_available_variant_compare_at_price > 0 ){
    str = '<span class="product-tag product-tag--sale product-tag--red"><img src="'+__sale_image+'" class="hide--mobile" /><img src="'+__sale_image_mobile+'" class="hide--desktop" /></span></span>';
    //str = '<img src="'+__sale_image+'" width=90 class="product-tag product-tag--sale product-tag--red"/>';

  }
  return str;
}
InfinityShowProduct.prototype.renderPrices=function(product){
  let str = "";
  //debugger;
  if( product.available ){
    if( product.compare_at_price > 0 ){
      str += '<span class="collection-grid-item__price--sale money-sale money">'+Shopify.formatMoney(product.compare_at_price)+'</span>&nbsp;';
    }
    str += '<span class="money">'+Shopify.formatMoney(product.price)+'</span>';
  } else {
    str += '<span class="money-style">SOLD OUT</span>';
  }
  return str;
}

InfinityShowProduct.prototype.updateURLState=function(){
  var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?current_page='+this.current_page;
  window.history.replaceState({path: newurl}, '', newurl);
}

InfinityShowProduct.prototype.renderTexts=function(product){
  let images = product.images;
  let str = "";
  for(let i=0;i<images.length;i++ ){
    if( i>=2 ) break;
    let image = images[i];
    if( i==0 ) {
      str += '<h3 class="collection-grid-item__title">'+product.title+'</h3>';
      //str += '<!-- Stamped - Begin Star Rating Badge --><span class=" stamped-product-reviews-badge" data-product-sku="'+product.handle+'" data-id="'+product.id+'" data-product-type="'+product.type+'" data-product-title="'+product.title+'"  style="display:block;"></span><!-- Stamped - End Star Rating Badge -->';
    }
  }
  return str;
}

InfinityShowProduct.prototype.renderImagesOld=function(product){
  let images = product.images;
  let str = "";
  for(let i=0;i<images.length;i++ ){
    if( i>=2 ) break;
    let image = images[i];
    //debugger;
    if (images.length == 1) {
      str = '<img class="collection-grid-item__image collection-grid-item__image--nohover  lazyloaded" src="'+image+'" alt="'+product.title+'">';
    } else {
      if (i==0) {
        str += '<img class="collection-grid-item__image lazyloaded" src="'+image+'" alt="'+product.title+'">';
      } else {
        str += '<img class="collection-grid-item__image--hover lazyloaded" data-src="'+image+'" src="'+image+'" alt="'+product.title+'">';
      }
    }
  }
  return str;
}

// new version with bloom
InfinityShowProduct.prototype.renderImages=function(product){
  if(!(this.bloom_collection_on)) {
    return this.renderImagesOld(product);

  } else {

    let images = product.images;
    let str = "";
    for(let i=0;i<images.length;i++ ){
      let image = images[i];

      // display them all, but hide them. bloom will query the server for which to show.
      str += '<img style="display:none;" class="bloom_media_' + product.id + '_' + (i+1) + ' collection-grid-item__image lazyloaded" src="'+image+'" alt="'+product.title+'">';
    }

    // show the hover behind
    if(images.length >= 2) {
      let image = images[1];
      str += '<img class="collection-grid-item__image--hover lazyloaded" data-src="'+image+'" src="'+image+'" alt="'+product.title+'">';
    }

    return str;
  }
}

function Utils() {

}

Utils.prototype = {
    constructor: Utils,
    isElementInView: function (element, fullyInView) {
        var pageTop = $(window).scrollTop();
        var pageBottom = pageTop + $(window).height();
        var elementTop = $(element).offset().top;
        var elementBottom = elementTop + $(element).height();

        if (fullyInView === true) {
            return ((pageTop < elementTop) && (pageBottom > elementBottom));
        } else {
            return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
        }
    }
};
var Utils = new Utils();


String.prototype.replaceAll  = function(s1,s2){   
  return this.replace(new RegExp(s1,"gm"),s2);   
}

const CONTROL_PCT = 0.5;

function checkIfInControl() {
  // X% of the time, be in control group
  var k = "bloomControlGroup_" + (new Date()).toDateString();
    // this works across all collections
  var v = localStorage.getItem(k);
  if(v === null) {
    // recalculate it
    v = (Math.random() < CONTROL_PCT) ? 1 : 0;
    localStorage.setItem(k, v);
    console.log("Recalculating " + k + ": " + v);
    return v;

  } else {
    console.log("Found " + k + ": " + (parseInt(v) == 1));
    // use the saved value
    return parseInt(v) == 1;
  }
}


InfinityShowProduct.prototype.bloomQueryVisiblePhotos = function(product) {
  function storageAvailable() {
    // https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
    var storage;
    try { storage = window['localStorage']; var x = '__storage_test__'; storage.setItem(x, x); storage.removeItem(x); return true; }
    catch(e) { return e instanceof DOMException && ( e.code === 22 || e.code === 1014 || e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && (storage && storage.length !== 0); }
  }

  function setPos(pos) {
    var e = document.getElementsByClassName("bloom_media_" + product.id + "_" + pos);
    if(e && e.length) {
      e = e[0];
      e.style.display = "inline";

    } else {
      console.log("Error: couldn't find elements with class name " + "bloom_media_" + product.id+ "_" + pos);
    }
  }

  function trackIfUnique(storageKey, pos, collection_id, isControl) {
    var k = storageKey + (new Date()).toDateString();
      // only track once per day per user
    if(localStorage.getItem(k)) {
      console.log("Already see tracked impression today");

    } else {
      localStorage.setItem(k, 1);
      console.log("Tracking for " + storageKey);
      fetch('//sh.getbloom.ai/api/track?event=gridImpression&collection_id=' + collection_id + '&product_id=' + product.id + '&position=' + pos + '&shop=badassveganlife.myshopify.com&control=' + (isControl ? 1 : 0));
    }
  }

  if(!(this.bloom_collection_on) || !(this.collection_id))
    return;

  if(!(window.fetch) || !(storageAvailable())) {
    setPos(1);

  } else {
    var storageKey = "grid&c=" + this.collection_id + "&p=" + product.id;

    if(checkIfInControl()) {
      setPos(1);
      localStorage.setItem(storageKey, 1);
      trackIfUnique(storageKey, 1, this.collection_id, true);

    } else {

      if(localStorage.getItem(storageKey)) {
        console.log("See " + storageKey);

        var pos = localStorage.getItem(storageKey);
        setPos(pos);
        trackIfUnique(storageKey, pos, this.collection_id, false);

      } else {
        console.log("fetching for " + storageKey);
        // todo if this doesn't work, set position 1
        fetch('//sh.getbloom.ai/api/getGridHeroPosition?collection_id=' + this.collection_id + '&product_id=' + product.id + '&numPositions=' + product.images.length + '&shop=badassveganlife.myshopify.com').then((res) => res.json()).then((data) => {

          if(data && data.position) {
            console.log("Setting " + storageKey + " to " + data.position);
            setPos(data.position);
            localStorage.setItem(storageKey, data.position);
            trackIfUnique(storageKey, data.position, this.collection_id, false);

          } else {
            console.log("Error: Invalid response. Setting to position 1.");
            setPos(1);
            trackIfUnique(storageKey, 1, this.collection_id, false);
          }

        }).catch((error) => {
          console.log("Error. Invalid response. Setting to position 1. ");
          console.log(error);
          setPos(1);
          trackIfUnique(storageKey, 1, this.collection_id, false);
        });
      }
    }

  }
};


/* remodal STARTS*/
$(document).ready(function(){ 
$('.remodal-close').on('click', function(e){ 
    e.preventDefault();
    //$(this).parent().hide();
    $('.remodal-overlay').trigger('click');
  
  });


// Youtube section
if($(".container--youtube").length > 0) {
  var tag = document.createElement('script');
      tag.src = "https://youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  var players = [];
   window.onYouTubeIframeAPIReady = function() {
    $('.container--youtube').each(function(i) {
	  var videoId = $(this).data('youtube-id');      
	  var playerId = 'player--' + videoId;
      players[i] = new YT.Player(playerId, {
        'height': '675',
        'width': '1200',
        'videoId': videoId,
        'playerVars': {
          'controls': 1,
          'showinfo': 0,
          'modestbranding': 0,
          'rel': 0
        }
      });             
    });
  }

  $(document).on('opening', '.remodal--youtube', function () {
   
    $modal = $(this);
    $.each(players, function(i,v) {
      var modalId = $modal.data('remodal-id').replace('modal-youtube--','');
      if (v.playerInfo.videoData.video_id == modalId) {
        v.playVideo(); 
      }
    });  
  });
  $(document).on('closed', '.remodal--youtube', function (e) {
    $modal = $(this);
    $.each(players, function(i,v) {
      var modalId = $modal.data('remodal-id').replace('modal-youtube--','');
      if (v.playerInfo.videoData.video_id == modalId) {
        v.stopVideo(); 
      }
    }); 
  });
} 
  }); 
/* remodal ENDS*/

 



